/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { useState, useEffect } from 'react'
import { toFlip, NO_ANIM } from '../actions/game'
import Card from './Card'
import letterE from '../decks/majs/le.svg'
import letterM from '../decks/majs/lm.svg'
import letterO from '../decks/majs/lo.svg'
import letterK from '../decks/majs/lk.svg'
import letterI from '../decks/majs/li.svg'
import letterD from '../decks/majs/ld.svg'
import { LEVELS, log } from '../logs'

const Title = props => {
  log('Title', LEVELS.INFO, props)
  const [name, setName] = useState([letterM, letterE, letterM, letterO, letterK, letterI, letterD].map((image, index) => ({
    image,
    transform: { r: (Math.random() - 0.5) * 10 },
    animTransform: NO_ANIM,
    flipped: true,
    animFlipped: NO_ANIM
  })))
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    log('Title', LEVELS.DEBUG, 'animate')
    if (!animating) {
      let letter = name.find((letter) => !letter.flipped)
      if (!letter) {
        letter = name[Math.floor(Math.random() * name.length)]
      }
      letter.animFlipped = {
        keyframes: [
          { offset: 0, ...toFlip(letter.flipped) },
          { offset: 1, ...toFlip(!letter.flipped) }
        ],
        timing: {
          duration: 600
        },
        onFinish: () => setAnimating(false)
      }
      letter.flipped = !letter.flipped
      setAnimating(true)
      setName(name)
    }
  }, [animating, name])

  return (
    <div className='title-name'>
      {
      name.map((letter, index) =>
        <div key={index}>
          <Card
            {...letter}
            size={100}
          />
        </div>)
    }
    </div>
  )
}
Title.displayName = 'Title'

export default Title
